import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import { GRADE_VALUES } from '../../../const';
import { I18n } from 'react-redux-i18n-lite';

const styles = {
  gradesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    margin: '0 36px'
  }
};

const getActiveOrInactive = (selectedGradeValue, gradeValue) => {
  if (selectedGradeValue === gradeValue) {
    return 'selected';
  }
};

/* selectedGrade -> 0 = saddest - 4 = happiest */
class GradesComponent extends React.Component {
  static propTypes = {
    selectedGrade: PropTypes.number,
    onGradeClick: PropTypes.func,
    emojis: PropTypes.object.isRequired,
    classes: PropTypes.object,
    hoverGrade: PropTypes.any
  };

  render() {
    let { classes, selectedGrade, emojis, onGradeClick } = this.props;

    return (
      <div className={classes.gradesContainer}>
        <div
          className={`grade-info ${getActiveOrInactive(selectedGrade, GRADE_VALUES.VERY_POOR)}`}
          onClick={() => onGradeClick(GRADE_VALUES.VERY_POOR)}
        >
          <img alt={I18n.t('tasks.gradeIcon.veryPoor')} src={emojis.emojiVeryPoorActive} />
          <span>{I18n.t('tasks.gradeIcon.veryPoor')}</span>
        </div>
        <div
          className={`grade-info ${getActiveOrInactive(selectedGrade, GRADE_VALUES.POOR)}`}
          onClick={() => onGradeClick(GRADE_VALUES.POOR)}
        >
          <img alt={I18n.t('tasks.gradeIcon.poor')} src={emojis.emojiPoorActive} />
          <span>{I18n.t('tasks.gradeIcon.poor')}</span>
        </div>
        <div
          className={`grade-info ${getActiveOrInactive(selectedGrade, GRADE_VALUES.ACCEPTABLE)}`}
          onClick={() => onGradeClick(GRADE_VALUES.ACCEPTABLE)}
        >
          <img alt={I18n.t('tasks.gradeIcon.acceptable')} src={emojis.emojiAcceptableActive} />
          <span>{I18n.t('tasks.gradeIcon.acceptable')}</span>
        </div>
        <div
          className={`grade-info ${getActiveOrInactive(selectedGrade, GRADE_VALUES.GOOD)}`}
          onClick={() => onGradeClick(GRADE_VALUES.GOOD)}
        >
          <img alt={I18n.t('tasks.gradeIcon.good')} src={emojis.emojiGoodActive} />
          <span>{I18n.t('tasks.gradeIcon.good')}</span>
        </div>
        <div
          className={`grade-info ${getActiveOrInactive(selectedGrade, GRADE_VALUES.EXCELLENT)}`}
          onClick={() => onGradeClick(GRADE_VALUES.EXCELLENT)}
        >
          <img alt={I18n.t('tasks.gradeIcon.excellent')} src={emojis.emojiExcellentActive} />
          <span>{I18n.t('tasks.gradeIcon.excellent')}</span>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(GradesComponent);
